import type CalendarSurfaceStore from '../schema/CalendarSurfaceStore';
import { mutatorAction } from 'satcheljs';

/**
 * Called to lock the currently selected item on surface.
 * @store The surface store
 */
export const unlockSelectedItem = mutatorAction(
    'unlockSelectedItems',
    (store: CalendarSurfaceStore) => {
        store.lockSelectedItem = false;
    }
);
